import { IconType } from "antd/lib/notification";
import ServiceConfig from "service.config.js";
import { $Notification } from "us.common/components";
import { versionedHttpCollection } from "us.helper/http/collection";

const openNotificationWithIcon = (
  type: IconType,
  msg: string,
  description: string,
  key: any
) => {
  $Notification[type]({
    message: msg,
    description: description,
    key,
  });
};

export const Invoice = {
  // search: async <P>(params: P): Promise<any> => {
  search: async <P extends {} | {}[]>(params: P): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status, statusText } =
          await versionedHttpCollection.global.post(
            "globalsearchservice",
            "invoices",
            params,
            ServiceConfig()[`searchservice`]["search.invoice"]
          );
        if (status === 200 || status === 204 || status === 202) {
          resolve({data, status});
        } else {
          openNotificationWithIcon(
            "error",
            status.toString(),
            statusText,
            Math.random()
          );
          reject(data);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
};

export const CaseDetail = {
  search: async <P extends {}>(params: P): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status, statusText } =
          await versionedHttpCollection.global.post(
            "globalsearchservice",
            "cases",
            params,
            ServiceConfig()[`searchservice`]["search.case"]
          );
        if (status === 200 || status === 204 || status === 202) {
          resolve({data, status});
        } else {
          openNotificationWithIcon(
            "error",
            status.toString(),
            statusText,
            Math.random()
          );
          reject(data);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
};

export const DebtorDetail = {
  search: async <P extends {} | {}[]>(params: P): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status, statusText } =
          await versionedHttpCollection.global.post<P>(
            "globalsearchservice",
            "debtors",
            params,
            ServiceConfig()[`searchservice`]["search.debtor"]
          );
        if (status === 200 || status === 204 || status === 202) {
          resolve({data, status});
        } else {
          openNotificationWithIcon(
            "error",
            status.toString(),
            statusText,
            Math.random()
          );
          reject(data);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
};

export const CreditorDetail = {
  // search: async <P>(params: P): Promise<any> => {
  search: async <P extends {} | {}[]>(params: P): Promise<any> => {
    return new Promise<any>(async (resolve, reject) => {
      try {
        const { data, status, statusText } =
          await versionedHttpCollection.global.post(
            "globalsearchservice",
            "creditors",
            params,
            ServiceConfig()[`searchservice`]["search.creditor"]
          );
        if (status === 200 || status === 204 || status === 202) {
          resolve({data, status});
        } else {
          openNotificationWithIcon(
            "error",
            status.toString(),
            statusText,
            Math.random()
          );
          reject(data);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
};

export const history = {
  get: async <P extends {} | {}[]>(): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data } = await versionedHttpCollection.global.get(
          "globalsearchservice",
          "history",
          {},
          ServiceConfig()[`searchservice`]["search.history"]
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  // save: async <P>(params: P): Promise<any> => {
  save: async <P extends {} | {}[]>(params: P): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status, statusText } =
          await versionedHttpCollection.global.post(
            "globalsearchservice",
            "history",
            params,
            ServiceConfig()[`searchservice`]["search.history"]
          );
        if (status === 200 || status === 204) {
          resolve(data);
        } else {
          openNotificationWithIcon(
            "error",
            status.toString(),
            statusText,
            Math.random()
          );
          reject(data);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
};

export const archivedCase = {
  get: async (params: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.get(
          "archiveservice",
          `search/${params?.searchNumber}`,
          {},
          "v1"
        );
        resolve({
          data,
          status,
        });
      } catch (error) {
        reject(error);
      }
    });
  },
  getDetails: async ({ exCaseNo }: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.get(
          "archiveservice",
          `archive/case/${exCaseNo}`,
          {},
          ServiceConfig()[`searchservice`]["search.history"]
        );
        resolve({
          data,
          status,
        });
      } catch (error) {
        reject(error);
      }
    });
  },
};

export const company = {
  get: async (params: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.get(
          "globalsearchservice",
          `company-config`,
          {},
          "v1"
        );
        resolve({
          data,
          status,
        });
      } catch (error) {
        reject(error);
      }
    });
  },
};

export const result = {
  get: async (params: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await versionedHttpCollection.get(
          "globalsearchservice",
          `result/${params}`,
          {},
          "v1"
        );
        if (status === 200 && data?.success) {
          resolve({ data, status });
        }
        else{
          openNotificationWithIcon(
            "error",
            "Search failed",
            "Search result could not be retrieved",
            Math.random()
          );
          reject(data);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
};
